let language = {
    "A112B1500013": "您输入的邮政编码与所选国家或地区不符",
    "A112B1500014": "连接服务器超时，请重试",
    "A112B712316": "送货地址问题，请更新您的地址，以确保您的订单正确到达。"
};

export { language }